import { useEffect, useState } from "react";
import { getListSidebar } from "../../../api/repositories";
import { getListMenu } from "../constant";
import { useDispatch } from "react-redux";

const useActions = () => {
  const [loadingSidebar, setLoadingSidebar] = useState(true);
  const [listSidebar, setListSidebar] = useState([]);

  const fetchListSidebar = async () => {
    setLoadingSidebar(true);

    try {
      const { data, status } = await getListSidebar();
      // const { data, status } = getListMenu

      if (status === 200) {
        getMenuName(data.menu);
      }
    } catch (error) {
      // console.log(error.message)
      setLoadingSidebar(false);
    } finally {
      setLoadingSidebar(false);
    }
  };

  const getMenuName = (dataMenu) => {
    const menuName = dataMenu.map((item, index) => {
      return item.name;
    });

    setListSidebar(menuName);
  };

  useEffect(() => {
    fetchListSidebar();
  }, []);

  return {
    loadingSidebar,
    listSidebar,
  };
};

export default useActions;
